









































import {Component, Vue, Prop} from 'vue-property-decorator';
import Carousel from '@/components/Carousel.vue';
import ItemTile from '@/components/ItemTile.vue';

@Component({
	components: {
		Carousel,
		ItemTile,
	},
})
export default class AppartmentDetails extends Vue {
	@Prop() private details!: object;
}
